<template>
  <prism-editor
    class="code-editor"
    v-model="editableCode"
    :code="code"
    :highlight="highlighter"
    :readonly="readonly"
    line-numbers
  ></prism-editor>
</template>

<script>
// import Prism Editor
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (can use any library you want just return  html string)
import { highlight, languages } from 'prismjs/components/prism-core';

// import syntax highlighting styles
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  data: () => ({}),
  props: {
    readonly: Boolean,
    code: String,
    input: [],
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js);
    },
    fetchData() {
      this.editableCode = this.code;
    },
  },
  mounted() {
    this.fetchData();
  },
  components: {
    PrismEditor,
  },
};
</script>

<style>
/* required class */
.code-editor {
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding-top: 5px;
}

/* required otherwise color is grey on grey */
.prism-editor__editor {
  color: white;
}

/* makes the whole editor area behave as input */
.prism-editor__container {
  height: 100%;
}
/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>
